






















import { Mobile } from "@/mixins/mobile";
import { Vue, Component, Prop, Mixins } from "vue-property-decorator";
@Component
export default class Search extends Mixins(Mobile) {
  @Prop({ default: "Enter search term..." }) placeholderText!: string;
  private search = "";

  public clearSearch() {
    this.search = "";
    this.sendSearch();
  }

  public sendSearch(): void {
    this.$emit("submitSearch", this.search);
  }
}
